import { render, staticRenderFns } from "./MovieDetails.vue?vue&type=template&id=8262be4c&"
import script from "./MovieDetails.vue?vue&type=script&lang=js&"
export * from "./MovieDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports